var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _vm.viewMode == "list"
                ? _c("span", { staticClass: "ik-list-title" }, [
                    _c(
                      "span",
                      { staticClass: "svg-container ik-list-icon" },
                      [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                      1
                    ),
                    _c("span", [_vm._v("数据列表")]),
                  ])
                : _vm._e(),
              _vm.viewMode === "list"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listCreateBtn },
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listUpdateBtn },
                        },
                        [_vm._v("修改")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDetailsBtn },
                        },
                        [_vm._v("详情")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listAllcBtn },
                        },
                        [_vm._v("调拨")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listBackBtn },
                        },
                        [_vm._v("回退")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode === "info"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCreateBtn },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoUpdateBtn },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCopyBtn },
                            },
                            [_vm._v("复制")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoDetailsBtn },
                            },
                            [_vm._v("详情")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.printOpen },
                            },
                            [_vm._v("打印")]
                          )
                        : _vm._e(),
                      _vm.mode == "add" || _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoSaveBtn },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.infoCancelBtn },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _vm.viewMode == "info"
                ? _c(
                    "el-form",
                    {
                      staticClass: "ik-info-head",
                      attrs: {
                        id: "ik-info-head",
                        inline: true,
                        "label-width": "120px",
                        disabled: _vm.mode == "details",
                      },
                      on: { validate: _vm.validate },
                      model: {
                        value: _vm.data.head,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "head", $$v)
                        },
                        expression: "data.head",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_id",
                                attrs: {
                                  code: "id",
                                  name: "ID",
                                  "default-value": 0,
                                  disabled: false,
                                },
                                model: {
                                  value: _vm.data.head["id"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "id", $$v)
                                  },
                                  expression: "data.head['id']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_code",
                                attrs: {
                                  code: "code",
                                  name: "编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                },
                                model: {
                                  value: _vm.data.head["code"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "code", $$v)
                                  },
                                  expression: "data.head['code']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-datetime", {
                                ref: "input_ordTime",
                                attrs: {
                                  code: "ordTime",
                                  name: "单据时间",
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                model: {
                                  value: _vm.data.head["ordTime"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "ordTime", $$v)
                                  },
                                  expression: "data.head['ordTime']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-datetime", {
                                ref: "input_businessTime",
                                attrs: {
                                  code: "businessTime",
                                  name: "业务时间",
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                model: {
                                  value: _vm.data.head["businessTime"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "businessTime", $$v)
                                  },
                                  expression: "data.head['businessTime']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_outPositionId",
                                attrs: {
                                  code: "outPositionId",
                                  name: "调出药库ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                model: {
                                  value: _vm.data.head["outPositionId"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "outPositionId",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['outPositionId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_outPositionCode",
                                attrs: {
                                  code: "outPositionCode",
                                  name: "调出药库编码",
                                  url: "clinic/inventory/inventory/position/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: { storeCode: _vm.storeCode },
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                on: { onPopupClick: _vm.headPopupClick },
                                model: {
                                  value: _vm.data.head["outPositionCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "outPositionCode",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['outPositionCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_outPositionName",
                                attrs: {
                                  code: "outPositionName",
                                  name: "调出药库名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                model: {
                                  value: _vm.data.head["outPositionName"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "outPositionName",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['outPositionName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_outPositionPositionSign",
                                attrs: {
                                  code: "outPositionPositionSign",
                                  name: "调出位置标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.positionSign),
                                  disabled: true,
                                  require: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value:
                                    _vm.data.head["outPositionPositionSign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "outPositionPositionSign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['outPositionPositionSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_outPositionClassifySign",
                                attrs: {
                                  code: "outPositionClassifySign",
                                  name: "调出分类标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.classifySign),
                                  disabled: true,
                                  require: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value:
                                    _vm.data.head["outPositionClassifySign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "outPositionClassifySign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['outPositionClassifySign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_inPositionId",
                                attrs: {
                                  code: "inPositionId",
                                  name: "调入药库ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                model: {
                                  value: _vm.data.head["inPositionId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "inPositionId", $$v)
                                  },
                                  expression: "data.head['inPositionId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_inPositionCode",
                                attrs: {
                                  code: "inPositionCode",
                                  name: "调入药库编码",
                                  url: "clinic/inventory/inventory/position/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {
                                    storeCode: _vm.storeCode,
                                    classifySign:
                                      _vm.data.head["outPositionClassifySign"],
                                  },
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                on: { onPopupClick: _vm.headPopupClick },
                                model: {
                                  value: _vm.data.head["inPositionCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "inPositionCode",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['inPositionCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_inPositionName",
                                attrs: {
                                  code: "inPositionName",
                                  name: "调入药库名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                model: {
                                  value: _vm.data.head["inPositionName"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "inPositionName",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['inPositionName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_inPositionPositionSign",
                                attrs: {
                                  code: "inPositionPositionSign",
                                  name: "调入位置标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.positionSign),
                                  disabled: true,
                                  require: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value:
                                    _vm.data.head["inPositionPositionSign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "inPositionPositionSign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['inPositionPositionSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_inPositionClassifySign",
                                attrs: {
                                  code: "inPositionClassifySign",
                                  name: "调入分类标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.classifySign),
                                  disabled: true,
                                  require: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value:
                                    _vm.data.head["inPositionClassifySign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "inPositionClassifySign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['inPositionClassifySign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_alloTypeId",
                                attrs: {
                                  code: "alloTypeId",
                                  name: "调拨类型ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                model: {
                                  value: _vm.data.head["alloTypeId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "alloTypeId", $$v)
                                  },
                                  expression: "data.head['alloTypeId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_alloTypeCode",
                                attrs: {
                                  code: "alloTypeCode",
                                  name: "调拨类型编码",
                                  url: "base/dictionary/datadic/datadictionary/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: { directoryCode: "AlloType" },
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                on: { onPopupClick: _vm.headPopupClick },
                                model: {
                                  value: _vm.data.head["alloTypeCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "alloTypeCode", $$v)
                                  },
                                  expression: "data.head['alloTypeCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_alloTypeName",
                                attrs: {
                                  code: "alloTypeName",
                                  name: "调拨类型名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                model: {
                                  value: _vm.data.head["alloTypeName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "alloTypeName", $$v)
                                  },
                                  expression: "data.head['alloTypeName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_executeSign",
                                attrs: {
                                  code: "executeSign",
                                  name: "执行标识",
                                  "default-value": "1",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.executeSign),
                                  disabled: true,
                                  require: true,
                                },
                                model: {
                                  value: _vm.data.head["executeSign"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "executeSign", $$v)
                                  },
                                  expression: "data.head['executeSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_sourceCode",
                                attrs: {
                                  code: "sourceCode",
                                  name: "来源单号",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                model: {
                                  value: _vm.data.head["sourceCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "sourceCode", $$v)
                                  },
                                  expression: "data.head['sourceCode']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode == "info"
                ? _c(
                    "el-tabs",
                    {
                      ref: "ik-info-body",
                      staticClass: "in-ord-tabs-info",
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          key: _vm.bodyMap[0].key,
                          staticStyle: { height: "100%" },
                          attrs: {
                            name: _vm.bodyMap[0].key,
                            label: _vm.bodyMap[0].name,
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                                {
                                  name: "horizontal-scroll",
                                  rawName: "v-horizontal-scroll",
                                  value: "always",
                                  expression: "'always'",
                                },
                              ],
                              ref: "tablesub",
                              staticClass: "ik-list-table",
                              attrs: {
                                data: _vm.data.body[_vm.bodyMap[0].key],
                                "element-loading-text": "加载中...",
                                stripe: true,
                                border: true,
                                fit: true,
                                height: "100%",
                                "header-row-class-name":
                                  "ik-list-table-header-row",
                                "header-cell-class-name":
                                  "ik-list-table-header-cell",
                                "row-class-name": "ik-list-table-body-row",
                                "cell-class-name": "ik-list-table-body-cell",
                                "highlight-current-row": true,
                              },
                            },
                            [
                              _vm.mode !== "details"
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "pluss",
                                      label: "操作",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "button-action",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        padding: "0px 12px",
                                                      },
                                                    },
                                                    [_vm._v("操作")]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "26px",
                                                        height: "26px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: {
                                                        circle: "",
                                                        title: "添加首行",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addRow(
                                                            _vm.activeTab,
                                                            -1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("+")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "button-action",
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "28px",
                                                        height: "28px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: { circle: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.addRow(
                                                            _vm.bodyMap[0].key,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("+")]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "28px",
                                                        height: "28px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: { circle: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.delRow(
                                                            _vm.bodyMap[0].key,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2391271428
                                    ),
                                  })
                                : _vm._e(),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "id",
                                  name: "ID",
                                  edit: _vm.mode !== "details",
                                },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "materielId",
                                  name: "药品ID",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "materielCode",
                                  name: "药品编码",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-data-popup", {
                                attrs: {
                                  code: "materielName",
                                  name: "药品名称",
                                  url: "clinic/inventory/inventory/inventory/find/findBatchInventoryPagination",
                                  "filed-list": [
                                    { code: "materielCode", name: "编码" },
                                    { code: "materielIotCode", name: "条码" },
                                    { code: "materielName", name: "名称" },
                                    { code: "batchCode", name: "批次" },
                                    {
                                      code: "qualitySign",
                                      name: "品质",
                                      type: "select",
                                      options: _vm.toJson(
                                        _vm.jsonStr.qualitySign
                                      ),
                                    },
                                    {
                                      code: "manufacturerName",
                                      name: "生产商",
                                    },
                                    { code: "supplierName", name: "供应商" },
                                    {
                                      code: "number",
                                      name: "余量",
                                      type: "number",
                                    },
                                    {
                                      code: "costPrice",
                                      name: "成本单价",
                                      type: "number",
                                    },
                                  ],
                                  "search-key": "materielName",
                                  searcher: {
                                    storeCode: _vm.storeCode,
                                    positionCode:
                                      _vm.data.head["outPositionCode"],
                                  },
                                  "popup-width": "100%",
                                  edit: _vm.mode !== "details",
                                },
                                on: {
                                  onFieldChange: _vm.onBodyFieldChange,
                                  onPopupClick: _vm.bodyPopupClick,
                                },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "supplierId",
                                  name: "供应商家ID",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-data-popup", {
                                attrs: {
                                  code: "supplierCode",
                                  name: "供应商家编码",
                                  url: "clinic/clinicdic/clinicmedicinedic/clinicchaindic/find/findPagination",
                                  "filed-list": [
                                    {
                                      code: "chainDictionaryCode",
                                      name: "编码",
                                    },
                                    {
                                      code: "chainDictionaryName",
                                      name: "名称",
                                    },
                                  ],
                                  "search-key": "chainDictionaryName",
                                  searcher: {
                                    storeCode: _vm.data.head["storeCode"],
                                    effectiveSign: "1",
                                  },
                                  edit: false,
                                },
                                on: {
                                  onFieldChange: _vm.onBodyFieldChange,
                                  onPopupClick: _vm.bodyPopupClick,
                                },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "supplierName",
                                  name: "供应商家名称",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "manufacturerId",
                                  name: "生产商家ID",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-data-popup", {
                                attrs: {
                                  code: "manufacturerCode",
                                  name: "生产商家编码",
                                  url: "clinic/clinicdic/clinicmedicinedic/clinicchaindic/find/findPagination",
                                  "filed-list": [
                                    {
                                      code: "chainDictionaryCode",
                                      name: "编码",
                                    },
                                    {
                                      code: "chainDictionaryName",
                                      name: "名称",
                                    },
                                  ],
                                  "search-key": "chainDictionaryName",
                                  searcher: {
                                    storeCode: _vm.data.head["storeCode"],
                                    effectiveSign: "1",
                                  },
                                  edit: false,
                                },
                                on: {
                                  onFieldChange: _vm.onBodyFieldChange,
                                  onPopupClick: _vm.bodyPopupClick,
                                },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "manufacturerName",
                                  name: "生产商家名称",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "chandi",
                                  name: "产地",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-select", {
                                attrs: {
                                  code: "qualitySign",
                                  name: "品质标识",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.qualitySign),
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "batchCode",
                                  name: "批次号",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-datetime", {
                                attrs: {
                                  code: "proDate",
                                  name: "生产日期",
                                  edit: false,
                                },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "expirationNumber",
                                  name: "保质期",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "number",
                                  name: "数量",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "costPrice",
                                  name: "成本单价",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "costAmount",
                                  name: "成本金额",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "querybg" },
                [
                  _vm.viewMode == "list"
                    ? _c(
                        "el-collapse",
                        {
                          staticClass: "ik-list-searcher",
                          attrs: { accordion: "" },
                          model: {
                            value: _vm.searcherActive,
                            callback: function ($$v) {
                              _vm.searcherActive = $$v
                            },
                            expression: "searcherActive",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              staticClass: "ik-list-searcher-item",
                              attrs: { title: "", name: "1" },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ik-list-searcher-item-titles",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "svg-container ik-list-icon",
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "search" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" 查询条件 "),
                                  ]
                                ),
                              ]),
                              _c(
                                "el-form",
                                {
                                  staticClass: "ik-info-head",
                                  attrs: {
                                    id: "ik-info-head",
                                    inline: true,
                                    "label-width": "120px",
                                    disabled: false,
                                  },
                                  model: {
                                    value: _vm.searcher,
                                    callback: function ($$v) {
                                      _vm.searcher = $$v
                                    },
                                    expression: "searcher",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_id",
                                            attrs: {
                                              code: "id",
                                              name: "ID",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["id"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "id",
                                                  $$v
                                                )
                                              },
                                              expression: "searcher['id']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_code",
                                            attrs: {
                                              code: "code",
                                              name: "编码",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["code"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "code",
                                                  $$v
                                                )
                                              },
                                              expression: "searcher['code']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_executeSign",
                                            attrs: {
                                              code: "executeSign",
                                              name: "执行标识",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.executeSign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["executeSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "executeSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['executeSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_sourceTypeSign",
                                            attrs: {
                                              code: "sourceTypeSign",
                                              name: "来源类型",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.sourceTypeSign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["sourceTypeSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "sourceTypeSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['sourceTypeSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_outPositionCode",
                                            attrs: {
                                              code: "outPositionCode",
                                              name: "调出药库编码",
                                              url: "clinic/inventory/inventory/position/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {},
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["outPositionCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "outPositionCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['outPositionCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_outPositionName",
                                            attrs: {
                                              code: "outPositionName",
                                              name: "调出药库名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["outPositionName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "outPositionName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['outPositionName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_inPpositionCode",
                                            attrs: {
                                              code: "inPositionCode",
                                              name: "调入药库编码",
                                              url: "clinic/inventory/inventory/position/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {},
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["inPositionCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "inPositionCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['inPositionCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_inPositionName",
                                            attrs: {
                                              code: "inPositionName",
                                              name: "调入药库名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["inPositionName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "inPositionName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['inPositionName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_alloTypeCode",
                                            attrs: {
                                              code: "alloTypeCode",
                                              name: "调拨类型编码",
                                              url: "base/dictionary/datadic/datadictionary/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {
                                                directoryCode: "AlloType",
                                              },
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["alloTypeCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "alloTypeCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['alloTypeCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_alloTypeName",
                                            attrs: {
                                              code: "alloTypeName",
                                              name: "调拨类型名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["alloTypeName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "alloTypeName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['alloTypeName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "query-class" }, [
                                _c(
                                  "div",
                                  { staticClass: "query-btn-warp" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.searchBtn },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.resetBtn },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.viewMode == "list"
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "table",
                      staticClass: "ik-list-table",
                      attrs: {
                        data: _vm.tableData,
                        "element-loading-text": "加载中...",
                        stripe: true,
                        border: true,
                        fit: true,
                        height: "calc(100% - 50px)",
                        "header-row-class-name": "ik-list-table-header-row",
                        "header-cell-class-name": "ik-list-table-header-cell",
                        "row-class-name": "ik-list-table-body-row",
                        "cell-class-name": "ik-list-table-body-cell",
                        "highlight-current-row": true,
                      },
                      on: { "row-click": _vm.rowClick },
                    },
                    [
                      _c("ik-column-id", {
                        attrs: { code: "id", name: "ID", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: { code: "code", name: "编码", edit: false },
                      }),
                      _c("ik-column-datetime", {
                        attrs: {
                          code: "ordTime",
                          name: "单据时间",
                          edit: false,
                        },
                      }),
                      _c("ik-column-datetime", {
                        attrs: {
                          code: "businessTime",
                          name: "业务时间",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: { code: "storeId", name: "门店ID", edit: false },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "outPositionId",
                          name: "调出药库ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "outPositionCode",
                          name: "调出药库编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "outPositionName",
                          name: "调出药库名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "inPositionId",
                          name: "调入药库ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "inPositionCode",
                          name: "调入药库编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "inPositionName",
                          name: "调入药库名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "alloTypeId",
                          name: "调拨类型ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "alloTypeCode",
                          name: "调拨类型编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "alloTypeName",
                          name: "调拨类型名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "executeSign",
                          name: "执行标识",
                          "key-field": "key",
                          "value-field": "value",
                          "default-value": "1",
                          options: _vm.toJson(_vm.jsonStr.executeSign),
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "sourceTypeSign",
                          name: "来源类型",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.sourceTypeSign),
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "sourceCode",
                          name: "来源单号",
                          edit: false,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _vm.viewMode == "list"
                ? _c("ik-pagination", {
                    ref: "ik_list_pagination",
                    attrs: {
                      "page-no": _vm.pagination.pageNo,
                      "page-size": _vm.pagination.pageSize,
                      "total-count": _vm.pagination.totalCount,
                    },
                    on: { pageChangeMethod: _vm.pageChange },
                  })
                : _c(
                    "el-row",
                    { staticClass: "ik-list-pagination", attrs: { gutter: 0 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "ik-list-enterprise-info",
                          attrs: { span: 6, offset: 12 },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(" 导萃门诊管理系统 "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c("InventoryP", { ref: "InventoryRef" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }